import { render } from "./form-page.vue?vue&type=template&id=7cd13b5a"
import script from "./form-page.vue?vue&type=script&lang=js"
export * from "./form-page.vue?vue&type=script&lang=js"

import "./form-page.vue?vue&type=style&index=0&id=7cd13b5a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__